// extracted by mini-css-extract-plugin
export default {"input":"components-settings-pms-integration-seasonal-room-offset-table-module__input"};